export const msgTypes = {
  addBet: {
    id: 'string',
    type: 'string',
  },
  app: {
    status: 'string',
  },
  categorizer: {
    isHide: 'boolean',
  },
  click: {
    target: 'string',
  },
  clickPlaceBet: {
    betType: 'string',
  },
  demo: {
    status: 'boolean',
  },
  demoBonuses: {
    isEnable: 'boolean',
  },
  openBetslip: {
    isOpen: 'boolean',
  },
  openMyBets: {
    isOpen: 'boolean',
  },
  openSearch: {
    isOpen: 'boolean',
  },
  parentGaps: {
    bottom: 'number',
    top: 'number',
  },
  placeBet: {
    amount: 'number',
    betType: 'string',
    bets: 'array',
  },
  placeBetError: {
    betType: 'string',
    error: 'string',
  },
  placeBetFailure: {
    status: 'string',
    statusId: 'number',
  },
  removeBet: {
    eventId: 'string',
    outcomeId: 'string',
    type: 'string',
  },
  requestGameLaunchUrl: {
    gameCode: 'string',
  },
  route: {
    location: 'string',
    type: 'string',
  },
  session: {
    reason: 'string',
    status: 'string',
  },
  setScrollPosition: {
    clientHeight: 'number',
    scrollHeight: 'number',
    scrollY: 'number',
  },
  size: {
    height: 'number',
  },
  socket: {
    reason: 'string',
    status: 'string',
  },
  themeEditor: {
    isEnable: 'boolean',
    isImported: 'boolean',
    isLightTheme: 'boolean',
    vars: 'object',
  },
  user: {
    authorized: 'boolean',
    cid: 'string',
  },
  vipSwitcher: {
    location: 'string',
    type: 'string',
  },
} as const;
